<script>
  import PrivacyPolicyScreen from '../../../module_core/module_business_term/screen/privacy-policy/PrivacyPolicyScreen.svelte'
</script>

<PrivacyPolicyScreen />
